import Api from "./Api";

export  const postVerifyStudent = (data) =>{
    return Api.post('/api/verify-student',data)
}

export const getRandomQuestions = () =>{
    return Api.get('/api/questions/random');
}

export const postSubmitScore = (data) =>{
    return Api.post('/api/submit-score',data);
}